import React, { Component } from 'react';

import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import DashboardEvents from '../../DashboardEvents';
import { getHelperCenterUrl } from '../../helpers';
import NavigationCard from '../navigationCard/NavigationCard';

import './LinkedCards.scss';

@translate()
class LinkedCards extends Component {
  static propTypes = {
    t: PropTypes.func,
    marketplaceId: PropTypes.number,
    shortLocale: PropTypes.string
  };

  handleClick = () => {
    DashboardEvents.clickOnHelpCenterLink(this.props.marketplaceId);
    this.redirectHelpPage();
  };

  redirectHelpPage() {
    const { shortLocale } = this.props;
    const url = getHelperCenterUrl(shortLocale);

    window.open(url, '_blank');
  }

  render() {
    const { t } = this.props;
    const icon = { prefix: 'fas', iconName: 'question-circle' };

    return (
      <>
        <h3 className="dashboard__article-help-title">
          {t('config_manager.help')}
        </h3>

        <section className="navigation-cards dashboard__item">
          <NavigationCard
            last
            data-test="faq-card"
            title={t('dashboard.faq_card.title')}
            description={t('dashboard.faq_card.description_v2')}
            icon={icon}
            onClick={this.handleClick}
          />
        </section>
      </>
    );
  }
}

export default LinkedCards;
